import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const GstSummarizer = Loadable(lazy(() => import("../gst/App")));
const AiContentTable = Loadable(lazy(() => import("../ai-legal-content/App")));

const directTaxRoutes = [
  { path: "/ai/gst/summarizer", element: <GstSummarizer />, auth: authRoles.guest},
  // { path: "/gst/rules/:id/*", element: <GstSumarrizer />, auth: authRoles.guest },

  { path: "/ai/content/:slug/*", element: <AiContentTable />, auth: authRoles.guest},

];

export default directTaxRoutes;
